import { render, staticRenderFns } from "./BudgetsNotCreatedDialog.vue?vue&type=template&id=0768c96d&scoped=true"
import script from "./BudgetsNotCreatedDialog.vue?vue&type=script&lang=js"
export * from "./BudgetsNotCreatedDialog.vue?vue&type=script&lang=js"
import style0 from "./BudgetsNotCreatedDialog.vue?vue&type=style&index=0&id=0768c96d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0768c96d",
  null
  
)

export default component.exports